import { ReactNode } from 'react';
import { useSmartLanguage } from '@/hooks/useSmartLanguage';

interface LanguageInitializerProps {
  children: ReactNode;
}

/**
 * Wrapper component that initializes language preference before rendering children.
 * Calls useSmartLanguage() so the priority chain (saved preference → geo-IP → fallback)
 * runs for every visitor on first load — not only when they open the LanguageSwitcher.
 */
export function LanguageInitializer({ children }: LanguageInitializerProps) {
  // Side-effect only: hook handles auth check, geo lookup and i18n.changeLanguage.
  useSmartLanguage();
  return <>{children}</>;
}
